import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import styles from '../spotbuild-integration.module.scss';
export const BuildContentSection = ({ label, title, children, }) => (React.createElement("div", { className: styles.buildContent },
    label && (React.createElement(Typography, { variant: "h5", className: styles.subHeading, color: Colors.grayLight }, label)),
    React.createElement(Typography, { variant: "h2", className: styles.mainHeading }, title),
    children));
//# sourceMappingURL=build-content-section.js.map